module.exports = __webpack_public_path__ + "img/image16-1.214b664a.png";